import { render, staticRenderFns } from "./TireRegisterPage.vue?vue&type=template&id=7bb17a42&scoped=true"
import script from "./TireRegisterPage.vue?vue&type=script&lang=ts"
export * from "./TireRegisterPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb17a42",
  null
  
)

export default component.exports